export default __webpack_public_path__ + "static/media/Animals_27.297555f6.png";